import { Component, OnInit } from '@angular/core';
import { CarouselResponse, CarouselRequest } from '@builtbybros/al-model';
import { HttpService } from '../shared/http.service';
import { QueryParam } from '../shared/query-param';
import { AlertService } from '../shared/alert.service';
import { DragulaService } from 'ng2-dragula';

@Component({
  selector: 'app-carousel',
  templateUrl: './carousel.component.html',
  styleUrls: ['./carousel.component.scss']
})
export class CarouselComponent implements OnInit {
  h1 = 'Carousel';
  carouselUrl = '/Carousel/';

  indexDrag: number;

  publicCarousels: CarouselResponse.Carousel[] = [];
  consigneeCarousels: CarouselResponse.Carousel[] = [];
  schoolCarousels: CarouselResponse.Carousel[] = [];

  publicCarouselsReady = false;
  consigneeCarouselsReady = false;
  schoolCarouselsReady = false;

  hasDataTables = true;
  entity = 'mailchimp';
  title = 'Carousel';
  actions = true;
  prevPath = 'list/';

  // [api param, column name, isSortable]
  columns = [
    // ['email', 'Correo electrónico', false], // userid.instituteName
    ['name', 'Nombre', false], // userid.contactName
  ];

  // [name, table header, isVisible]
  actionColumns = [
    ['highlight', 'Destacar', false],
    ['edit', 'Editar', true],
    ['delete', 'Eliminar', true]
  ];

  constructor(private httpService: HttpService,
    private alertService: AlertService,
    private dragulaService: DragulaService) {
    dragulaService.drag.subscribe((value) => {
      this.onDrag(value.slice(1));
    });
    dragulaService.drop.subscribe((value) => {
      this.onDrop(value.slice(1), value[0]);
    });
    dragulaService.over.subscribe((value) => {
      this.onOver(value.slice(1));
    });
    dragulaService.out.subscribe((value) => {
      this.onOut(value.slice(1));
    });
  }

  ngOnInit() {
    this.httpService.getWithParams('/Carousel/All', [new QueryParam('roles', '2')], CarouselResponse.All)
      .subscribe(response => {
        this.publicCarousels = response['objects'];
        this.publicCarouselsReady = true;
      });
    this.httpService.getWithParams('/Carousel/All', [new QueryParam('roles', '3')], CarouselResponse.All)
      .subscribe(response => {
        this.consigneeCarousels = response['objects'];
        this.consigneeCarouselsReady = true;
      });
    this.httpService.getWithParams('/Carousel/All', [new QueryParam('roles', '4')], CarouselResponse.All)
      .subscribe(response => {
        this.schoolCarousels = response['objects'];
        this.schoolCarouselsReady = true;
      });
  }

  delete(value) {
    if (confirm('eliminar?')) {
      this.httpService.delete('/Carousel/', value)
        .subscribe(response => {
          let index;
          index = this.publicCarousels.findIndex((item) => {
            return item.id === +value;
          });
          if (index !== -1) {
            this.publicCarousels.splice(index, 1);
          }
          index = this.consigneeCarousels.findIndex((item) => {
            return item.id === +value;
          });
          if (index !== -1) {
            this.consigneeCarousels.splice(index, 1);
          }
          index = this.schoolCarousels.findIndex((item) => {
            return item.id === +value;
          });
          if (index !== -1) {
            this.schoolCarousels.splice(index, 1);
          }
        });
    }
  }

  /**
   * Update displaced carousels
   *
   * @param position this is the new order for the carousel who was moved
   * @param distance difference between older and new order
   * @param upward if new order < old order
   * @param rol
   * @param carousel
   */
  fixOrders(position: number, distance: number, upward: boolean, rol: number, carousel: CarouselResponse.Carousel[]) {
    let idDisplacedCarousel;
    let newOrderDisplacedCarousel;
    // iterates between the the older position to the new position updating the carousels order
    if (upward) {
      for (let i = 1; i <= distance; i++) {
        idDisplacedCarousel = this.publicCarousels[position + i].id;
        newOrderDisplacedCarousel = position + i;
        this.onUpdateOrder(newOrderDisplacedCarousel, rol, idDisplacedCarousel);
      }
    } else {
      for (let i = 1; i <= distance; i++) {
        idDisplacedCarousel = this.publicCarousels[position - i].id;
        newOrderDisplacedCarousel = position - i;
        this.onUpdateOrder(newOrderDisplacedCarousel, rol, idDisplacedCarousel);
      }
    }
  }

  onUpdateOrder(Order: number, carouselRol: number, idCar: number) {
    const expectedResponse = new CarouselResponse.Carousel();
    const carousel = new CarouselRequest.Update();
    const carouselOrder = new CarouselRequest.Order();
    carousel.order = [];
    carouselOrder.order = Order;
    carouselOrder.role = carouselRol;
    carousel.order.push(carouselOrder);
    return this.httpService.patch(idCar, this.carouselUrl, carousel, expectedResponse).subscribe((res) => {
      alert('Órden Actualizado')
    });
  }

  updateOrder(newOrder: number, carouselName: string) {
    let idCarousel;
    let rol;
    let distance;
    // Get carousel id
    if (carouselName) {
      if (carouselName === 'publish-bag') {
        idCarousel = this.publicCarousels[newOrder].id;
        if (newOrder > this.indexDrag) {
          distance = newOrder - this.indexDrag;
          this.fixOrders(newOrder, distance, false, 2, this.publicCarousels);
        } else {
          distance = this.indexDrag - newOrder;
          this.fixOrders(newOrder, distance, true, 2, this.publicCarousels);
        }
        rol = 2;
      } else if (carouselName === 'consignee-bag') {
        idCarousel = this.consigneeCarousels[newOrder].id;
        if (newOrder > this.indexDrag) {
          distance = newOrder - this.indexDrag;
          this.fixOrders(newOrder, distance, false, 3, this.consigneeCarousels);
        } else {
          distance = this.indexDrag - newOrder;
          this.fixOrders(newOrder, distance, true, 3, this.consigneeCarousels);
        }
        rol = 3;
      } else {
        idCarousel = this.schoolCarousels[newOrder].id;
        if (newOrder > this.indexDrag) {
          distance = newOrder - this.indexDrag;
          this.fixOrders(newOrder, distance, false, 4, this.schoolCarousels);
        } else {
          distance = this.indexDrag - newOrder;
          this.fixOrders(newOrder, distance, true, 4, this.schoolCarousels);
        }
        rol = 4;
      }
    }
    // Update drag carousel order
    return this.onUpdateOrder(newOrder, rol, idCarousel);
  }

  private onDrag(args) {
    let [e, el] = args;
    this.indexDrag = this.getElementIndex(e);
  }

  private onDrop(args, name: string) {
    let [e, el] = args;
    // Get new order for element
    const indexDrop = this.getElementIndex(e);
    const res = this.updateOrder(indexDrop, name);

    console.log(res)
  }

  private onOver(_args) {
    // let [e, el, container] = args;
    // do something
  }

  private onOut(_args) {
    // let [e, el, container] = args;
    // do something
  }

  // Get element index in the list
  private getElementIndex(el: any) {
    return [].slice.call(el.parentElement.children).indexOf(el);
  }
}



// WEBPACK FOOTER //
// ./src/app/carousel/carousel.component.ts